(function () {
  var items = document.querySelectorAll('.header-category-bar__nav-item--has-dropdown');

  function openDropdown(item, dropdown) {
    var rect = item.getBoundingClientRect();
    dropdown.style.left = rect.left + 'px';
    dropdown.style.top = rect.bottom + 'px';
    dropdown.classList.add('is-open');
  }

  function closeDropdown(dropdown) {
    dropdown.classList.remove('is-open');
  }

  items.forEach(function (item) {
    var dropdown = item.querySelector('.header-category-bar__dropdown');
    if (!dropdown) return;

    item.addEventListener('mouseenter', function () {
      openDropdown(item, dropdown);
    });
    item.addEventListener('mouseleave', function () {
      closeDropdown(dropdown);
    });
    item.addEventListener('focusin', function () {
      openDropdown(item, dropdown);
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) {
        closeDropdown(dropdown);
      }
    });
  });
})();
